import React, { FC } from "react";
import { redirectKeyPressToClick } from "../../../../helpers/interactionHandlers";
import { LocationIconSvg } from "../../../icons/LocationIconSvg";
import { StyledLocationText, StyledWrapper } from "./index.styled";

export interface LocationProps {
  onClickHandler?: (event: React.MouseEvent) => void;
  zipCode?: string | null;
}

interface Location {
  keepMobileMenuOpen?: (keepOpen: boolean) => void;
  location: LocationProps;
}

export const Location: FC<Location> = ({ keepMobileMenuOpen, location }) => {
  const { onClickHandler, zipCode } = location;

  const onClicks = (event: React.MouseEvent) => {
    // close the mobile menu, if mobile
    if (keepMobileMenuOpen) {
      keepMobileMenuOpen(false);
    }
    // take the handled action
    if (onClickHandler) onClickHandler(event);
  };
  return (
    <StyledWrapper
      data-testid="ui-header-location"
      onClick={onClicks}
      onKeyDown={redirectKeyPressToClick}
      tabIndex={0}
    >
      <LocationIconSvg />
      <StyledLocationText>
        {zipCode ? zipCode : "Deliver to"}
      </StyledLocationText>
    </StyledWrapper>
  );
};
